import { withInstall } from '@bigin/utils'
import CheckTag from './src/check-tag.vue'

export const BCheckTag = withInstall(CheckTag)
export default BCheckTag

export * from './src/check-tag'
